import {
    AuthType,
    MfaStatusEnum,
    PasswordChangeRequest,
    User
} from "../types";
import { Config } from "@/shared/config";
import { CognitoUser } from "amazon-cognito-identity-js";
import _ from "lodash";
import { CognitoAuth as Cognito } from "@/shared/api/cognito_auth";
import { OktaAuth as Okta } from "@/shared/api/okta_auth";
import { useUserStore } from "@/shared/store/user";

const cognito = new Cognito();
const okta = new Okta();

class AuthenticationFactory {
    getAuth (): Authentication {
        const userStore = useUserStore();
        return userStore.authType === AuthType.Okta ? okta : cognito;
    }

    getAuthByType (authType: AuthType): Authentication {
        return authType === AuthType.Okta ? okta : cognito;
    }
}

export const AuthFactory: AuthenticationFactory = new AuthenticationFactory();
export const CognitoAuth: Cognito = cognito;
export const OktaAuth: Okta = okta;

export interface Authentication {
    login: (username: string, password: string, requiredGroups: ReadonlyArray<string>,
            mfaFunc: (s: MfaStatusEnum, u: CognitoUser) => void) => Promise<User>;
    setInitialPassword: (username: string, oldPassword: string, newPassword: string,
                         mfaFunc: (s: MfaStatusEnum, u: CognitoUser) => void) => Promise<User>;
    logout: () => void;
    accessToken: () => Promise<string>;
    forceRefreshSession: () => Promise<User>;
    resetPassword: (username: string) => Promise<any>;
    autoRecoverUser: (email: string) => Promise<any>;
    confirmPassword: (username: string, verificationCode: string, password: string) => Promise<any>;
    setAdmin: () => void;
    getUser: () => { username };
    changePassword: (request: PasswordChangeRequest) => Promise<void>;
}
